import { c as _c } from "react/compiler-runtime";
export const ShoppingCartIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  const t1 = className || "h-6 w-6";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M2.25 2.25a.75.75 0 000 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 00-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 000-1.5H5.378A2.25 2.25 0 017.5 15h11.218a.75.75 0 00.674-.421 60.358 60.358 0 002.96-7.228.75.75 0 00-.525-.965A60.864 60.864 0 005.68 4.509l-.232-.867A1.875 1.875 0 003.636 2.25H2.25zM3.75 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16.5 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={t1}>{t2}</svg>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};